import { parsePropertySourceIdSmartPropertyResultId, parsePropertySourceSmartDataCaptureSuggestionId } from 'customer-data-objects/property/PropertySourceIdentifier';
export function parseCitationSource(source) {
  if (source.citationType === 'smartPropertyResultId' || source.citationType === 'smartDataCaptureSuggestionId') {
    return source;
  } else {
    const maybeSmartPropertyResultId = parsePropertySourceIdSmartPropertyResultId(source.citationId);
    const maybeSmartDataCaptureSuggestionId = parsePropertySourceSmartDataCaptureSuggestionId(source.citationId);
    if (maybeSmartPropertyResultId) {
      return {
        citationType: 'smartPropertyResultId',
        citationId: maybeSmartPropertyResultId
      };
    } else if (maybeSmartDataCaptureSuggestionId) {
      return {
        citationType: 'smartDataCaptureSuggestionId',
        citationId: maybeSmartDataCaptureSuggestionId.suggestionId
      };
    }
  }
  return null;
}